/**
 * Les modals du portail colloc
 */
export const ModalTypes = {
  CGU: '#cguModal',
  LOGOUT: '#modal-deconnexion',
  EXTERNAL_LINK: '#modal-external-link',
};
